"use client"
/* */
import { useState } from 'react';

const useStatic = (factory) => useState(() => factory())[0];

export { useStatic };
//# sourceMappingURL=useStatic.mjs.map
